import { api } from './api';
import { ResponseType } from '../types/shared.types';
import {
  GetNotificationsParams,
  NotificationEntity,
  NotificationsUnreadResponse,
} from '../types/notification.types';

/**
 * The bell. The same routes in the admin and the merchant app, and the list is
 * the caller's own. See `types/notification.types` for the domain.
 */

/** Newest first. No total: a page shorter than `limit` is the last one. */
export const getNotifications = (params: GetNotificationsParams) =>
  api.get<ResponseType<NotificationEntity[]>>('/v1/notifications', {
    params,
  });

/** The badge's starting number. After that the socket carries it. */
export const getNotificationsUnreadCount = () =>
  api.get<ResponseType<NotificationsUnreadResponse>>(
    '/v1/notifications/unread-count'
  );

/**
 * Answers with the new unread count. Someone else's or an already read one is
 * not an error - nothing changes and the current count comes back.
 */
export const markNotificationAsSeen = (notificationId: number) =>
  api.post<ResponseType<NotificationsUnreadResponse>>(
    `/v1/notifications/${notificationId}/mark-as-seen`
  );

/** Answers with the new unread count, which is 0. */
export const markAllNotificationsAsSeen = () =>
  api.post<ResponseType<NotificationsUnreadResponse>>(
    '/v1/notifications/mark-all-as-seen'
  );
